import { groupBy } from 'ramda'
import React from 'react'
import { useTheme } from '@mui/material'
import NoticesSection from './NoticesSection'

const SECTIONS = [
    {
        type: 'error',
        title: 'שגיאות',
    },
    {
        type: 'warning',
        title: 'אזהרות',
    },
    {
        type: 'info',
        title: 'הערות',
    },
]

export default function NoticesSectionsContainer({ notices }) {
    const theme = useTheme()

    const groupedNotices = groupBy((notice) => notice.type, notices)

    return SECTIONS.map((sectionOptions) => {
        const { type, ...sectionProps } = sectionOptions
        const colors = theme.palette.badgeColors[type]
        return (
            <NoticesSection
                item
                key={type}
                notices={groupedNotices[type]}
                bgColor={colors.background}
                color={colors.text}
                {...sectionProps}
            />
        )
    })
}
